// extracted by mini-css-extract-plugin
export default {"headers":"Signout_headers__Pj6fq","sign":"Signout_sign__FasVf","btn":"Signout_btn__559T7","btn1":"Signout_btn1__yRYTP","btn2":"Signout_btn2__0H0ia"};